module.exports = __webpack_public_path__ + "img/IMG-20201222-WA0012.3ec2fcb6.jpg";